import {Component, OnInit} from '@angular/core';
import {enableAkitaProdMode} from "@datorama/akita";
import {environment} from "../environments/environment";
import {ProjectService} from "./store/base/project.service";
import {ConfigService} from "./store/config/config.service";
import {EdgeAuthService} from "./store/auth/edge-auth.service";
import {RequestStoreService} from "./store/request/request-store.service";
import {CustomerStoreService} from "./store/customer/customer-store.service";
import {BookingStoreService} from "./store/booking/booking-store.service";


@Component({
  selector: 'as-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private edgeAuthService: EdgeAuthService,
    private configService: ConfigService,
    private projectService: ProjectService,
    private requestService: RequestStoreService,
    private bookingService: BookingStoreService,
    private customerService: CustomerStoreService,
  ) {
    this.edgeAuthService.refresh();
    this.configService.init();
    if (environment.production) {
      enableAkitaProdMode();
    }
  }
  ngOnInit(): void {
    this.projectService.init();
    this.customerService.init();
    this.requestService.init();
    this.bookingService.init();
  }

}
